(function() {
  'use strict';
  
  const PRODUCTION_MODE = false;
  let productCache = {};
  let productCacheTimestamps = {};
  const CACHE_TTL = 10 * 60 * 1000; // 10 dakika cache süresi
  let setGroups = new Map();
  let isUpdating = false;
  let debounceTimer = null;
  
  function log(...args) {
    if (!PRODUCTION_MODE) {
      console.log('[Cart Set]', ...args);
    }
  }

  function isEN() {
    try {
      if (window.Shopify && window.Shopify.locale && String(window.Shopify.locale).toLowerCase().startsWith('en')) return true;
    } catch (e) {}
    const path = (location && location.pathname) || '';
    return /^\/en(\/|$)/i.test(path);
  }

  const I18N = {
    setProductBadge: { tr: 'Set Ürünü',                en: 'Set Product' },
    lotsUnit:        { tr: 'lot',                       en: 'lots' },
    setContents:     { tr: 'Set İçeriği:',             en: 'Set Contents:' },
    total:           { tr: (n) => `Toplam: ${n} ürün`, en: (n) => `Total: ${n} pcs` },
    stockLimit:      { tr: 'Stok sınırı',              en: 'Stock limit' },
    soldOut:         { tr: 'Tükendi',                  en: 'Sold out' },
    lastInStock:     { tr: 'Stoktaki son ürünler sepetinizde.', en: 'Last items in stock are in your cart.' },
    productSoldOut:  { tr: 'Ürün tükendi.',            en: 'Product is sold out.' },
    cartUpdated:     { tr: 'Sepet güncellendi',        en: 'Cart updated' },
    info:            { tr: 'Bilgi',                     en: 'Info' },
    warning:         { tr: 'Uyarı',                     en: 'Warning' },
    stockReduced:    { tr: 'Stok azaldı, sepet güncellendi.', en: 'Stock reduced, cart updated.' },
    cartUpdating:    { tr: 'Sepet güncelleniyor.',     en: 'Cart updating.' },
    setRemoved:      { tr: 'Set sepetten kaldırıldı.', en: 'Set removed from cart.' },
    errorReloading:  { tr: 'Bir hata oluştu, sayfa yenileniyor.', en: 'An error occurred, reloading page.' },
    lotUpdateError:  { tr: 'Lot güncellenirken hata oluştu', en: 'Error while updating lot' },
    removedFromCart: { tr: (m) => `-${m} adet (1 set) çıkarıldı`, en: (m) => `-${m} items (1 set) removed` }
  };

  function T(key, ...args) {
    const entry = I18N[key];
    if (!entry) return '';
    const val = isEN() ? (entry.en || entry.tr) : entry.tr;
    return typeof val === 'function' ? val(...args) : val;
  }

  // Kapsamlı set bilgisi parse fonksiyonu (quantity-multiplier.js'den uyarlanmış)
  function parseCompleteSetInfo(description, productTitle) {
    if (!description) return null;

    // DEBUG: Ham description'ı logla
    log('RAW DESCRIPTION:', description.substring(0, 500));

    let cleanText = description.toString().trim();
    cleanText = cleanText.replace(/<[^>]*>/g, '');
    cleanText = cleanText.replace(/&[a-zA-Z0-9#]+;/g, '');
    cleanText = cleanText.replace(/^\*+/g, '');
    cleanText = cleanText.replace(/\*+$/g, '');
    cleanText = cleanText.replace(/\*/g, '');
    cleanText = cleanText.replace(/[\r\n\t\f\v]/g, ' ');
    cleanText = cleanText.replace(/\s+/g, ' ');
    cleanText = cleanText.trim();

    log('CLEAN TEXT:', cleanText.substring(0, 500));
    
    // 1. BEDEN SETİ FORMATI — TR ("Beden Seti:" + "Dağılım:") veya EN ("Size Set:" + "Distribution:")
    const bedenSetiLabel = cleanText.includes('Beden Seti:') ? 'Beden Seti:'
      : cleanText.includes('Size Set:') ? 'Size Set:' : null;
    const dagitimLabel = cleanText.includes('Dağılım:') ? 'Dağılım:'
      : cleanText.includes('Distribution:') ? 'Distribution:' : null;
    if (bedenSetiLabel && dagitimLabel) {
      const variantDistributions = {};
      const sections = cleanText.split(bedenSetiLabel);

      for (let i = 1; i < sections.length; i++) {
        const section = sections[i];
        const dagitimParts = section.split(dagitimLabel);

        if (dagitimParts.length > 1) {
          const bedenRange = dagitimParts[0].replace(/[()]/g, '').trim();
          const dagitimContent = dagitimParts[1].split(/Model Bilgisi|Barkod|Teknik|Fabric|Composition|Care|$/)[0].trim();
          
          let totalQty = 0;
          const sizeMap = {};
          
          // XS:1 - S:1 - M:1 - L:1 ve 26:1 - 27:1 ve S/M:2 formatlarını parse et
          const matches = dagitimContent.matchAll(/([A-Z]{1,3}(?:\/[A-Z]{1,3})?|\d{1,3}):(\d+)/g);
          for (const match of matches) {
            const size = match[1];
            const qty = parseInt(match[2]);
            sizeMap[size] = qty;
            totalQty += qty;
          }
          
          if (totalQty > 0) {
            variantDistributions[bedenRange] = {
              total: totalQty,
              sizes: sizeMap
            };
          }
        }
      }
      
      if (Object.keys(variantDistributions).length > 0) {
        // Her range için toplam miktarı hesapla
        const totalPerRange = {};
        for (const [range, info] of Object.entries(variantDistributions)) {
          totalPerRange[range] = info.total;
        }

        log('Beden Seti formatı:', variantDistributions);
        return {
          type: 'beden_seti',
          distributions: variantDistributions,
          isMultiSize: true,
          totalPerRange: totalPerRange
        };
      }
    }
    
    // 2. SET İÇERİK BİLGİSİ FORMATI — TR/EN etiket varyantları
    let setContent = null;

    // Etiket varyantları: Türkçe + İngilizce + ASCII varyantları
    const setLabelCandidates = [
      'Set İçerik Bilgisi:',
      'Set Icerik Bilgisi:',
      'Set Contents Information:',
      'Set Contents:',
      'Set Content:'
    ];
    let setLabelVariant = null;
    for (const cand of setLabelCandidates) {
      if (cleanText.includes(cand)) { setLabelVariant = cand; break; }
    }

    if (setLabelVariant) {
      const parts = cleanText.split(setLabelVariant);
      if (parts.length > 1) {
        // End-marker: bu kelimelerden biri gelince setContent biter
        // TR: Teknik/Kumaş/Kalıp/Kol/Beden/Bakım/Ürün/Barkod
        // EN: Fabric/Composition/Care/Material/Product/Size/Technical/Barcode
        const endMarkers = [
          'Model Bilgisi', 'Teknik', 'Kumaş', 'Kalıp', 'Kol', 'Beden', 'Bakım', 'Ürün', 'Barkod',
          'Fabric', 'Composition', 'Care', 'Material', 'Product', 'Size', 'Technical', 'Barcode'
        ];
        let content = parts[1];
        // Icerikte EN ERKEN gecen marker'dan kes (dizi sirasina gore degil).
        // Aksi halde "134-236-238-140 Model Bilgisi..." gibi iceriklerde yanlis
        // marker secilip set icerigi yabanci metinle birlesiyor ve rakamli
        // beden formati cop parse ediliyordu (#1018 eksik set vakasinin koku).
        let earliestIdx = -1;
        for (const marker of endMarkers) {
          const idx = content.indexOf(marker);
          if (idx !== -1 && (earliestIdx === -1 || idx < earliestIdx)) {
            earliestIdx = idx;
          }
        }
        if (earliestIdx !== -1) content = content.slice(0, earliestIdx);
        setContent = content.trim();
      }
    }

    // 3. DAĞILIM / DISTRIBUTION FORMATI
    if (!setContent) {
      const distLabel = cleanText.includes('Dağılım:') ? 'Dağılım:'
        : cleanText.includes('Distribution:') ? 'Distribution:' : null;
      if (distLabel) {
        const parts = cleanText.split(distLabel);
        if (parts.length > 1) {
          setContent = parts[1].split(/Model Bilgisi|Teknik|Kumaş|Barkod|Fabric|Composition|Care|Material/)[0].trim();
        }
      }
    }

    // DEBUG: Set içeriğini logla
    if (setContent) {
      log('SET CONTENT (RAW):', JSON.stringify(setContent));
      log('SET CONTENT (length):', setContent.length);
    }

    // Set içeriğini parse et
    if (setContent) {
      const distribution = {};
      let hasMultipleSizes = false;

      // Geçerli beden isimleri - quantity-multiplier.js ile uyumlu
      const excludedWords = new Set(['TRY', 'USD', 'EUR', 'GBP', 'ADET', 'KG', 'TL', 'MAL', 'VE', 'BR', 'DIV', 'EM', 'TEK']);
      const validSizes = new Set(['S', 'M', 'L', 'XL', 'XXL', 'XXXL', 'XS', '1XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL']);
      const extendedSizes = new Set(['1XL', '2XL', '3XL', '4XL', '5XL', '6XL', '7XL']);

      // YENİ: Yaş bazlı beden formatı - "7-8-1  9-10-1  11-12-1"
      const ageRangeMatches = [...setContent.matchAll(/(\d{1,2}-\d{1,2})-(\d{1,2})/g)];
      if (ageRangeMatches.length > 0) {
        log('Age-range format detected in cart parser');
        for (const match of ageRangeMatches) {
          const ageRange = match[1];
          const quantity = parseInt(match[2]);
          if (quantity > 0 && quantity <= 100) {
            distribution[ageRange] = quantity;
            hasMultipleSizes = true;
          }
        }
        if (hasMultipleSizes) {
          const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);
          return { type: 'multi_size_set', distribution, isMultiSize: true, totalPerSet };
        }
      }

      // YENİ: Extended size+qty formatı - "1XL1-2XL1-3XL1-4XL1"
      const extSizeQtyMatches = [...setContent.matchAll(/(\d[A-Z]{1,3})(\d{1,2})(?=[-\s]|$)/gi)];
      if (extSizeQtyMatches.length > 0) {
        for (const match of extSizeQtyMatches) {
          const sizeName = match[1].toUpperCase();
          const quantity = parseInt(match[2]);
          if (extendedSizes.has(sizeName) && quantity > 0) {
            distribution[sizeName] = quantity;
            hasMultipleSizes = true;
          }
        }
        if (hasMultipleSizes) {
          const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);
          return { type: 'multi_size_set', distribution, isMultiSize: true, totalPerSet };
        }
      }

      // YENİ: Extended size isimleri adet olmadan - "1XL-2XL-3XL-4XL"
      const extSizeOnlyMatches = [...setContent.matchAll(/(\d[A-Z]{1,3})(?=[-\s]|$)/gi)];
      if (extSizeOnlyMatches.length > 0) {
        let extFound = false;
        for (const match of extSizeOnlyMatches) {
          const sizeName = match[1].toUpperCase();
          if (extendedSizes.has(sizeName)) {
            distribution[sizeName] = 1;
            extFound = true;
            hasMultipleSizes = true;
          }
        }
        if (extFound && Object.keys(distribution).length > 0) {
          const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);
          return { type: 'multi_size_set', distribution, isMultiSize: true, totalPerSet };
        }
      }

      // YENİ: SIZE+QTY bitişik format - "S1-M1-L1-XL1"
      const sizeQtyAttachedMatches = [...setContent.matchAll(/([A-Z]{1,4})(\d{1,2})(?=[-\s]|$)/gi)];
      if (sizeQtyAttachedMatches.length > 0) {
        for (const match of sizeQtyAttachedMatches) {
          const size = match[1].toUpperCase();
          const quantity = parseInt(match[2]);
          if (validSizes.has(size) && !excludedWords.has(size) && !extendedSizes.has(size) && quantity > 0) {
            distribution[size] = quantity;
            hasMultipleSizes = true;
          }
        }
        if (hasMultipleSizes) {
          const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);
          return { type: 'multi_size_set', distribution, isMultiSize: true, totalPerSet };
        }
      }

      // YENİ: Parantez formatı - "(S-M)-3" veya "(S-M):3"
      const parenthesisPattern = /\(([A-Z]+(?:-[A-Z]+)*)\)\s*[-:=]\s*(\d+)/gi;
      const parenthesisMatches = [...setContent.matchAll(parenthesisPattern)];

      if (parenthesisMatches.length > 0) {
        log('Parenthesis format detected in cart parser');
        for (const match of parenthesisMatches) {
          const sizeName = match[1].toUpperCase();
          const quantity = parseInt(match[2]);
          if (quantity > 0 && quantity <= 100) {
            distribution[sizeName] = quantity;
            hasMultipleSizes = true;
            log(`Parenthesis format found: (${sizeName})-${quantity}`);
          }
        }
      }

      // YENI: Tire içeren beden isimleri - "S-M-3" veya "L-XL:2"
      // Önce potansiyel tire içeren beden isimlerini tespit et
      if (!hasMultipleSizes) {
        // "S-M-3" veya "S-M:3" veya "S-M=3" formatları
        const compoundSizePattern = /([A-Z]+-[A-Z]+)\s*[-:=]\s*(\d+)/gi;
        const compoundMatches = [...setContent.matchAll(compoundSizePattern)];

        if (compoundMatches.length > 0) {
          log('Compound size format detected in cart parser');
          for (const match of compoundMatches) {
            const sizeName = match[1].toUpperCase();
            const quantity = parseInt(match[2]);
            if (quantity > 0 && quantity <= 100) {
              distribution[sizeName] = quantity;
              hasMultipleSizes = true;
              log(`Compound size found: ${sizeName}-${quantity}`);
            }
          }
        }
      }

      // ÖNCE "1XS-2S-2M-1L" veya "2S-2M-2L" formatını dene (quantity-size, qty önce)
      // Bu CSV'deki yaygın format — yanlışlıkla size-quantity tarafından yanlış parse edilmesin
      if (!hasMultipleSizes) {
        const quantitySizePattern = /(\d+)\s*([A-Z]{1,4})(?=\s|-|$)/g;
        let matches = [...setContent.matchAll(quantitySizePattern)];

        if (matches.length > 0) {
          log('Quantity-size pattern matched, count:', matches.length);
          matches.forEach(match => {
            const qty = parseInt(match[1]);
            const size = match[2].toUpperCase();
            if (validSizes.has(size) && !excludedWords.has(size) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Quantity-size found: ${qty}${size}`);
            }
          });
        }
      }

      // YENİ: Sayısal birleşik qty+size formatı — "134-236-238-140" = 1×34, 2×36, 2×38, 1×40
      // Pantolon/etek bedenleri için yaygın (sayısal beden: 26-60)
      // size-quantity pattern'inden ÖNCE kontrol et — yoksa "134-23" olarak yanlış parse eder
      if (!hasMultipleSizes) {
        const chunks = setContent.split(/\s*-\s*/).map(c => c.trim()).filter(Boolean);
        const allNumeric = chunks.length >= 2 && chunks.every(c => /^\d{3,4}$/.test(c));
        if (allNumeric) {
          log('Numeric concatenated format candidate:', chunks);
          const tempDist = {};
          let valid = true;
          for (const chunk of chunks) {
            let qty, size;
            if (chunk.length === 3) {
              // 1 digit qty + 2 digit size: "134" = 1×34
              qty = parseInt(chunk[0]);
              size = chunk.substring(1);
            } else {
              // 4 digit: önce qty(1)+size(3), size pants range'inde değilse qty(2)+size(2)
              const sizeAs2 = parseInt(chunk.substring(2));
              if (sizeAs2 >= 20 && sizeAs2 <= 99) {
                qty = parseInt(chunk.substring(0, 2));
                size = chunk.substring(2);
              } else {
                qty = parseInt(chunk[0]);
                size = chunk.substring(1);
              }
            }
            const sizeNum = parseInt(size);
            if (qty > 0 && qty <= 100 && sizeNum >= 10 && sizeNum <= 200) {
              tempDist[size] = qty;
            } else {
              valid = false;
              break;
            }
          }
          if (valid && Object.keys(tempDist).length === chunks.length) {
            Object.assign(distribution, tempDist);
            hasMultipleSizes = true;
            log('Numeric concatenated qty+size format:', distribution);
          }
        }
      }

      // SONRA "S-2 M-2 L-4 XL-4" veya "44-1 46-2" formatını dene (size-quantity, size önce)
      if (!hasMultipleSizes) {
        const sizeQuantityPattern = /([A-Z]{1,4}|\d{2,3})\s*[-:]\s*(\d{1,2})/g;
        let matches = [...setContent.matchAll(sizeQuantityPattern)];

        if (matches.length > 0) {
          log('Size-quantity pattern matched, count:', matches.length);
          matches.forEach(match => {
            const size = match[1].toUpperCase();
            const qty = parseInt(match[2]);
            const isNumericSize = /^\d{2,3}$/.test(size);
            if ((isNumericSize || (validSizes.has(size) && !excludedWords.has(size))) && qty > 0 && qty <= 100) {
              distribution[size] = qty;
              hasMultipleSizes = true;
              log(`Size-quantity found: ${size}-${qty}`);
            }
          });
        }
      }
      
      if (hasMultipleSizes && Object.keys(distribution).length > 0) {
        // Toplam miktar hesapla
        const totalPerSet = Object.values(distribution).reduce((sum, qty) => sum + qty, 0);

        log('Multi-size set bulundu:', distribution);
        return {
          type: 'multi_size_set',
          distribution: distribution,
          isMultiSize: true,
          totalPerSet: totalPerSet
        };
      }
    }
    
    // 4. PAKET YAPISI / PACKAGE STRUCTURE FORMATI
    const paketLabel = cleanText.includes('Paket Yapısı:') ? 'Paket Yapısı:'
      : cleanText.includes('Package Structure:') ? 'Package Structure:'
      : cleanText.includes('Package:') ? 'Package:' : null;
    if (paketLabel) {
      const paketRegex = new RegExp(paketLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*(.+?)(?:Teknik|Kumaş|Barkod|Fabric|Composition|Care|Material|$)', 'i');
      const paketMatch = cleanText.match(paketRegex);
      if (paketMatch) {
        const paketContent = paketMatch[1].trim();
        // '+' ile ayrılmış kısımları say veya sayısal değer bul
        let multiplier = 1;

        // "1S+1M+1L+1XL" gibi formatlar için
        const plusParts = paketContent.split('+').filter(p => p.trim());
        if (plusParts.length > 1) {
          multiplier = plusParts.length;
        } else {
          // Direkt sayı formatı için
          const numMatch = paketContent.match(/(\d+)/);
          if (numMatch) {
            multiplier = parseInt(numMatch[1]);
          }
        }

        log('Paket Yapısı formatı:', multiplier);
        return {
          type: 'paket_yapisi',
          multiplier: multiplier,
          isMultiSize: false
        };
      }
    }

    // 5. STD FORMATI
    // "5xSTANDART", "5xSTD", "STD-5", "STD:5" gibi formatları destekle
    let stdMatch = cleanText.match(/(\d+)\s*x\s*STAN[DA]*R[DT]/i);
    if (!stdMatch) {
      stdMatch = cleanText.match(/STD\s*[-:]\s*(\d+)/);
    }
    if (!stdMatch) {
      stdMatch = cleanText.match(/(\d+)\s*x\s*STD/i);
    }

    if (stdMatch) {
      const multiplier = parseInt(stdMatch[1]);
      log('STD formatı bulundu:', multiplier, 'Pattern:', stdMatch[0]);
      return {
        type: 'std',
        multiplier: multiplier,
        isMultiSize: false
      };
    }

    // 6. ÜRÜN ADINDAN SET BİLGİSİ
    if (productTitle) {
      const titleUpper = productTitle.toUpperCase();
      const setPatterns = [
        /(\d+)\s*[''']?\s*[Ll][İIıi]\s*[Ss][Ee][Tt]/,
        /(\d+)\s*[Aa][Dd][Ee][Tt]/,
        /(\d+)\s*[Ll][İIıi]\s*[Pp][Aa][Kk][Ee][Tt]/
      ];
      
      for (const pattern of setPatterns) {
        const match = titleUpper.match(pattern);
        if (match) {
          const multiplier = parseInt(match[1]);
          if (multiplier > 1) {
            return {
              type: 'title_based',
              multiplier: multiplier,
              isMultiSize: false
            };
          }
        }
      }
    }
    
    return null;
  }
  
  // Ürün bilgilerini al (cache TTL destekli)
  async function getProductSetInfo(handle) {
    // Cache'de varsa ve süresi dolmamışsa kullan
    if (productCache[handle] && productCacheTimestamps[handle]) {
      if (Date.now() - productCacheTimestamps[handle] < CACHE_TTL) {
        const cached = productCache[handle];
        // Retail işaretli ürün → set değil
        return (cached && cached.__retail) ? null : cached;
      }
      // Süresi dolmuş, temizle
      delete productCache[handle];
      delete productCacheTimestamps[handle];
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;

      const product = await response.json();

      // RETAIL ETİKETİ — set/lot mantığı uygulanmaz, ürün perakende satılır
      const tags = (product.tags || []).map(t => String(t).toLowerCase().trim());
      if (tags.includes('retail')) {
        productCache[handle] = { __retail: true };
        productCacheTimestamps[handle] = Date.now();
        log(`${handle}: 'retail' etiketli — set işleme atlanıyor (perakende)`);
        return null;
      }

      const setInfo = parseCompleteSetInfo(product.description, product.title);

      if (setInfo) {
        setInfo.handle = handle;
        setInfo.productId = product.id;
        setInfo.title = product.title;
        setInfo.variants = product.variants;

        productCache[handle] = setInfo;
        productCacheTimestamps[handle] = Date.now();
        log(`Set bilgisi (${handle}):`, setInfo);
      }

      return setInfo;
    } catch (error) {
      log('Ürün bilgisi alınamadı:', error);
      return null;
    }
  }
  
  // Helper: Variant title'dan size ve color çıkar
  function extractSizeAndColor(variantTitle, distribution, isBedenSeti) {
    const parts = (variantTitle || '').split('/').map(p => p.trim().toUpperCase().replace(/[()]/g, '').trim()).filter(Boolean);
    let sizeKey = null;
    if (distribution && Object.keys(distribution).length > 0) {
      const sizes = Object.keys(distribution).sort((a, b) => b.length - a.length);
      for (const variantPart of parts) {
        if (sizeKey) break;
        for (const size of sizes) {
          const sizeUpper = size.toUpperCase();
          if (variantPart === sizeUpper) { sizeKey = size; break; }
          if (!isBedenSeti && sizeUpper.includes('-')) {
            const sp = sizeUpper.split('-').map(s => s.trim());
            if (sp.includes(variantPart)) { sizeKey = size; break; }
          }
        }
      }
    }
    if (!sizeKey) {
      const stdSizes = ['XXXL', 'XXL', 'XL', 'L', 'M', 'S', 'XS'];
      for (const variantPart of parts) {
        if (sizeKey) break;
        if (stdSizes.includes(variantPart)) { sizeKey = variantPart; break; }
        if (/^\d{2,3}$/.test(variantPart)) { sizeKey = variantPart; break; }
      }
    }
    let color = '_default';
    if (parts.length) {
      const sizeUpper = sizeKey ? sizeKey.toUpperCase() : '';
      const colorParts = parts.filter(p => p && p !== sizeUpper);
      color = colorParts.length ? colorParts.join('|') : '_default';
    }
    return { size: sizeKey, color };
  }

  // variant_id üzerinden renk kimliği — variant_title parse'ına bağımlı değil (sağlam)
  // size dışındaki tüm opsiyonlar pipe ile birleştirilip color identity döner
  function getVariantColorIdentity(variantId, setInfo, normalizedDistribution) {
    if (!setInfo || !setInfo.variants || !variantId) return null;
    const vid = typeof variantId === 'string' ? parseInt(variantId, 10) : variantId;
    const variant = setInfo.variants.find(v => v.id === vid || v.id === variantId);
    if (!variant) return null;

    const distSizes = new Set(Object.keys(normalizedDistribution || {}).map(s => String(s).toUpperCase()));
    const stdSizes = new Set(['XS','S','M','L','XL','XXL','XXXL','1XL','2XL','3XL','4XL','5XL','6XL','7XL']);
    const opts = [variant.option1, variant.option2, variant.option3];

    let sizeIdx = -1;
    for (let i = 0; i < opts.length; i++) {
      const v = opts[i] == null ? '' : String(opts[i]).trim().toUpperCase();
      if (!v) continue;
      if (distSizes.has(v) || stdSizes.has(v) || /^\d{2,3}$/.test(v) || /^\d{1,2}-\d{1,2}$/.test(v)) {
        sizeIdx = i;
        break;
      }
    }
    if (sizeIdx === -1) {
      for (let i = opts.length - 1; i >= 0; i--) {
        if (opts[i] != null && String(opts[i]).trim() !== '') { sizeIdx = i; break; }
      }
    }

    const colorParts = [];
    for (let i = 0; i < opts.length; i++) {
      if (i === sizeIdx) continue;
      if (opts[i] == null) continue;
      const v = String(opts[i]).trim().toUpperCase();
      if (v) colorParts.push(v);
    }
    return colorParts.length ? colorParts.join('|') : '_default';
  }

  // Composite group key: handle::color (aynı handle farklı renkler ayrı grup)
  function makeGroupKey(handle, color) {
    return `${handle}::${color || '_default'}`;
  }

  // Variant stok verisini al — önce window.__cartVariantStocks (Liquid-rendered, en güvenilir),
  // sonra fallback: variant.inventory_quantity (Shopify /products/{handle}.js)
  // Returns: { stock: number|null, policy: string|null, available: bool|null }
  function getVariantStockData(variantId, fallbackVariant) {
    const result = { stock: null, policy: null, available: null };

    // Window'dan oku
    if (typeof window !== 'undefined' && window.__cartVariantStocks) {
      const data = window.__cartVariantStocks[variantId] || window.__cartVariantStocks[String(variantId)];
      if (data) {
        if (typeof data.stock === 'number') result.stock = data.stock;
        if (data.policy) result.policy = data.policy;
        if (typeof data.available === 'boolean') result.available = data.available;
      }
    }

    // Fallback: variant data (cached from /products/{handle}.js)
    if (fallbackVariant) {
      if (result.stock == null && typeof fallbackVariant.inventory_quantity === 'number') {
        result.stock = fallbackVariant.inventory_quantity;
      }
      if (!result.policy && fallbackVariant.inventory_policy) {
        result.policy = fallbackVariant.inventory_policy;
      }
      if (result.available == null && typeof fallbackVariant.available === 'boolean') {
        result.available = fallbackVariant.available;
      }
    }

    return result;
  }

  // ============ LOT ALGORİTMASI ============
  // Set İçerik Bilgisi (ideal dağılım) önceliklidir. Stok ideal'e tam bölünmezse:
  //   Katman 1: ideal setler  →  Katman 2: T parçalık dengeli karma lotlar
  // (Katman 3 — kısmi lot — KAPALI. T'den az kalan stok satılmaz.)
  // computeLots sıralı bir lot listesi döner; maxLot = liste uzunluğu.

  // Round-robin: stoktan T parça dengeli al (her turda stoğu olan her bedenden 1'er)
  function balancedTake(stockObj, T) {
    const result = {};
    const sizes = Object.keys(stockObj);
    for (const s of sizes) result[s] = 0;
    let taken = 0, guard = 0;
    while (taken < T && guard < 100000) {
      guard++;
      let progressed = false;
      for (const s of sizes) {
        if (taken >= T) break;
        if ((stockObj[s] || 0) - result[s] > 0) {
          result[s]++; taken++; progressed = true;
        }
      }
      if (!progressed) break;
    }
    return result;
  }

  // ideal: {size: qty}, stock: {size: qty} → sıralı lot listesi [{type, dist}]
  function computeLots(ideal, stock) {
    const idealSizes = Object.keys(ideal || {});
    const T = idealSizes.reduce((a, s) => a + (ideal[s] || 0), 0);
    const lots = [];
    if (T <= 0) return lots;

    const kalan = {};
    for (const s of Object.keys(stock || {})) kalan[s] = Math.max(0, stock[s] || 0);
    for (const s of idealSizes) if (!(s in kalan)) kalan[s] = 0;

    // Katman 1 — ideal setler
    let idealAdet = Infinity;
    for (const s of idealSizes) {
      if ((ideal[s] || 0) <= 0) continue;
      const possible = Math.floor((kalan[s] || 0) / ideal[s]);
      if (possible < idealAdet) idealAdet = possible;
    }
    if (!isFinite(idealAdet) || idealAdet < 0) idealAdet = 0;
    for (let i = 0; i < idealAdet; i++) {
      const dist = {};
      for (const s of idealSizes) { dist[s] = ideal[s]; kalan[s] -= ideal[s]; }
      lots.push({ type: 'ideal', dist });
    }

    const sumKalan = () => Object.keys(kalan).reduce((a, s) => a + Math.max(0, kalan[s]), 0);

    // Katman 2 — karma lotlar (T parça, dengeli)
    let guard = 0;
    while (sumKalan() >= T && guard < 5000) {
      guard++;
      const lot = balancedTake(kalan, T);
      const lotSum = Object.keys(lot).reduce((a, s) => a + lot[s], 0);
      if (lotSum < T) break;
      const dist = {};
      for (const s of Object.keys(lot)) {
        kalan[s] -= lot[s];
        if (lot[s] > 0) dist[s] = lot[s];
      }
      lots.push({ type: 'karma', dist });
    }

    // Katman 3 KAPALI — kısmi lot eklenmez. T parçalık tam/karma lotlardan
    // küçük kalan stok satılmaz (tükendi sayılır). Müşteri istegi:
    // "set toplamı 6'ysa en fazla N tam set, kalan stok eklenmesin".
    return lots;
  }

  // İlk n lotun dağılımları toplamı → {size: qty}
  function mergeLotsUnion(lots, n) {
    const union = {};
    const limit = Math.max(0, Math.min(n, lots.length));
    for (let i = 0; i < limit; i++) {
      for (const [s, q] of Object.entries(lots[i].dist || {})) {
        union[s] = (union[s] || 0) + q;
      }
    }
    return union;
  }

  // Sepetteki size→qty dağılımını lot listesiyle eşleştir → mevcut lot sayısı N
  function matchLotCount(cartBySize, lots) {
    const cartTotal = Object.keys(cartBySize).reduce((a, s) => a + (cartBySize[s] || 0), 0);
    if (cartTotal <= 0 || !lots.length) return 0;
    // 1) Birebir per-size eşleşme
    for (let n = lots.length; n >= 1; n--) {
      const u = mergeLotsUnion(lots, n);
      const sizes = new Set([...Object.keys(u), ...Object.keys(cartBySize)]);
      let exact = true;
      for (const s of sizes) {
        if ((u[s] || 0) !== (cartBySize[s] || 0)) { exact = false; break; }
      }
      if (exact) return n;
    }
    // 2) Toplam parça sayısı eşleşmesi
    for (let n = lots.length; n >= 1; n--) {
      const uTotal = Object.values(mergeLotsUnion(lots, n)).reduce((a, b) => a + b, 0);
      if (uTotal === cartTotal) return n;
    }
    // 3) cartTotal'i aşmayan en büyük N
    let best = 1;
    for (let n = 1; n <= lots.length; n++) {
      const uTotal = Object.values(mergeLotsUnion(lots, n)).reduce((a, b) => a + b, 0);
      if (uTotal <= cartTotal) best = n;
    }
    return best;
  }

  // Variant'tan {size, color} çıkar (option1/2/3 üzerinden, distribution'a göre normalize)
  function getVariantSizeAndColor(variant, normalizedDistribution) {
    const distKeys = Object.keys(normalizedDistribution || {});
    const distSizes = new Set(distKeys.map(s => String(s).toUpperCase()));
    const stdSizes = new Set(['XS','S','M','L','XL','XXL','XXXL','1XL','2XL','3XL','4XL','5XL','6XL','7XL']);
    const opts = [variant.option1, variant.option2, variant.option3];
    let sizeIdx = -1;
    for (let i = 0; i < opts.length; i++) {
      const v = opts[i] == null ? '' : String(opts[i]).trim().toUpperCase();
      if (!v) continue;
      if (distSizes.has(v) || stdSizes.has(v) || /^\d{2,3}$/.test(v) || /^\d{1,2}-\d{1,2}$/.test(v)) {
        sizeIdx = i; break;
      }
    }
    if (sizeIdx === -1) {
      for (let i = opts.length - 1; i >= 0; i--) {
        if (opts[i] != null && String(opts[i]).trim() !== '') { sizeIdx = i; break; }
      }
    }
    let size = sizeIdx >= 0 && opts[sizeIdx] != null ? String(opts[sizeIdx]).trim() : '';
    for (const dk of distKeys) {
      if (String(dk).toUpperCase() === size.toUpperCase()) { size = dk; break; }
    }
    const colorParts = [];
    for (let i = 0; i < opts.length; i++) {
      if (i === sizeIdx || opts[i] == null) continue;
      const v = String(opts[i]).trim().toUpperCase();
      if (v) colorParts.push(v);
    }
    return { size, color: colorParts.length ? colorParts.join('|') : '_default' };
  }

  // Grup için lot listesi — ideal=group.distribution, stok=bu rengin TÜM varyantları
  // Returns: { lots, sizeVariantMap, stockBySize, maxLots, hasTrustworthyStock }
  function computeGroupLots(group) {
    const ideal = group.distribution || {};
    const variants = (group.info && group.info.variants) ? group.info.variants : [];
    const stockBySize = {};
    const sizeVariantMap = {};
    let hasTrustworthyStock = false;

    // Grubun rengini sepetteki ilk item'ın variant'ından, ürün varyantlarıyla AYNI
    // fonksiyonla türet — string format tutarsızlığından kaynaklı sıfır-lot riskini önler
    let groupColor = null;
    for (const item of group.items) {
      const v = variants.find(vv => vv.id === item.variant_id || vv.id === item.id);
      if (v) { groupColor = getVariantSizeAndColor(v, ideal).color; break; }
    }
    if (groupColor == null) groupColor = group.color;

    for (const variant of variants) {
      const sc = getVariantSizeAndColor(variant, ideal);
      if (sc.color !== groupColor) continue;      // sadece bu rengin varyantları
      if (!sc.size) continue;
      const sd = getVariantStockData(variant.id, variant);
      let stockNum = 0;
      if (typeof sd.stock === 'number') {
        stockNum = Math.max(0, sd.stock);
        hasTrustworthyStock = true;
      } else if (sd.available === false) {
        stockNum = 0;
        hasTrustworthyStock = true;
      }
      stockBySize[sc.size] = (stockBySize[sc.size] || 0) + stockNum;
      if (!sizeVariantMap[sc.size]) sizeVariantMap[sc.size] = variant.id;
    }

    const lots = computeLots(ideal, stockBySize);
    return { lots, sizeVariantMap, stockBySize, maxLots: lots.length, hasTrustworthyStock };
  }

  // Bir set grubunu hedef lot birleşimine getir (eksik varyantları ekle, fazlaları sil — atomik)
  async function applyLotTarget(group, sizeVariantMap, union) {
    const cart = await fetch('/cart.js').then(r => r.json());
    const cartVariantIds = new Set((cart.items || []).map(i => i.variant_id));

    // union'da olup sepette olmayan varyantları ekle
    const toAdd = [];
    for (const size of Object.keys(union)) {
      const vid = sizeVariantMap[size];
      if (!vid) { log('applyLotTarget: variant bulunamadı, size:', size); continue; }
      if ((union[size] || 0) > 0 && !cartVariantIds.has(vid)) {
        toAdd.push({ id: vid, quantity: union[size] });
      }
    }
    if (toAdd.length) {
      log('applyLotTarget: eksik varyantlar ekleniyor', toAdd);
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: toAdd })
        });
      } catch (e) { log('applyLotTarget add hatası:', e); }
    }

    // Tüm renk varyantlarını hedef miktara getir (variant_id keyli, atomik)
    const fd = new FormData();
    for (const size of Object.keys(sizeVariantMap)) {
      fd.append(`updates[${sizeVariantMap[size]}]`, String(union[size] || 0));
    }
    const r = await fetch('/cart/update.js', { method: 'POST', body: fd });
    log('applyLotTarget /cart/update.js →', r.status);
  }

  // Sepet yüklenince stok-üstü setleri otomatik düşür — checkout'a gitmeden bütünlük korunur
  let autoCorrectInProgress = false;
  let autoCorrectAttemptedThisLoad = false;
  async function autoCorrectOverstockSets() {
    if (autoCorrectInProgress || autoCorrectAttemptedThisLoad) return false;
    autoCorrectInProgress = true;
    autoCorrectAttemptedThisLoad = true;

    isUpdating = true;
    try {
      const warnings = [];
      let anyChange = false;

      for (const [groupKey, group] of setGroups.entries()) {
        if (!group.info || !group.info.isMultiSize) continue;

        const { lots, sizeVariantMap, maxLots, hasTrustworthyStock } = computeGroupLots(group);
        if (!hasTrustworthyStock) {
          log(`Auto-correct ${group.info.title}: stok verisi yok, atlanıyor`);
          continue;
        }

        const cartBySize = {};
        for (const item of group.items) {
          if (item.size) cartBySize[item.size] = (cartBySize[item.size] || 0) + (item.quantity || 0);
        }
        const currentN = matchLotCount(cartBySize, lots);

        // SADECE gerçek stok-aşımında müdahale et: sepette stoğun izin verdiğinden
        // FAZLA lot varsa düşür. Aksi halde sepete DOKUNMA (drift hizalama yok —
        // "kendi kendine siliniyor" şikayetinin sebebi buydu).
        if (currentN <= maxLots) {
          log(`Auto-correct ${group.info.title}: ${currentN} lot ≤ ${maxLots} max — dokunulmuyor`);
          continue;
        }
        const targetN = maxLots;
        // Stok tamamen tükenmişse (hedef 0) sepeti sessizce boşaltma — checkout halleder
        if (targetN < 1) {
          log(`Auto-correct ${group.info.title}: max 0 lot — dokunulmuyor`);
          continue;
        }
        const targetUnion = mergeLotsUnion(lots, targetN);

        log(`Auto-correct: ${group.info.title} — stok aşımı, ${currentN} lot → ${targetN} lot`);
        await applyLotTarget(group, sizeVariantMap, targetUnion);
        anyChange = true;
        warnings.push({ title: group.info.title, from: currentN, to: targetN });
      }

      if (!anyChange) return false;

      if (warnings.length) {
        showNotification(T('stockReduced'), 'warning');
      }

      // Sayfayı yenile (kullanıcı düzeltilmiş hâli görsün)
      setTimeout(() => window.location.reload(), 2200);
      return true;
    } catch (err) {
      console.error('[Cart Set] auto-correct hatası:', err);
      return false;
    } finally {
      isUpdating = false;
      autoCorrectInProgress = false;
    }
  }

  // Sepetteki set ürünlerini grupla
  async function groupSetItems() {
    let cart;
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      cart = await response.json();
    } catch (error) {
      log('Cart verisi alınamadı:', error);
      return;
    }
    if (!cart || !cart.items) return;
    setGroups.clear();
    
    for (const item of cart.items) {
      const handle = item.handle || item.url?.split('/products/')[1]?.split('?')[0];
      if (!handle) continue;
      
      const setInfo = await getProductSetInfo(handle);
      if (!setInfo) continue;
      
      // Multi-size set için gruplama
      if (setInfo.isMultiSize) {
        // Distribution'ı normalize et — hem 'distribution' hem 'distributions' olabilir
        let normalizedDistribution = {};
        let isBedenSeti = false;
        if (setInfo.distribution) {
          normalizedDistribution = setInfo.distribution;
        } else if (setInfo.distributions) {
          isBedenSeti = true;
          for (const [range, info] of Object.entries(setInfo.distributions)) {
            normalizedDistribution[range] = info.total || Object.values(info.sizes || {}).reduce((s, q) => s + q, 0);
          }
        }

        // RENK BAZLI GRUP KEY — aynı handle farklı renkler ayrı set gruplarına düşer
        const variantTitle = item.variant_title || item.title || '';
        const sc = extractSizeAndColor(variantTitle, normalizedDistribution, isBedenSeti);
        const groupKey = makeGroupKey(handle, sc.color);

        if (!setGroups.has(groupKey)) {
          setGroups.set(groupKey, {
            info: setInfo,
            handle: handle,
            color: sc.color,
            items: [],
            distribution: normalizedDistribution,
            isBedenSeti: isBedenSeti,
            totalPerSet: setInfo.totalPerSet || setInfo.totalPerRange || Object.values(normalizedDistribution).reduce((sum, qty) => sum + qty, 0)
          });
        }

        const group = setGroups.get(groupKey);

        // Hangi bedene ait olduğunu bul (variantTitle yukarıda tanımlandı)
        log(`--- Cart item: "${item.product_title}" ---`);
        log(`Variant title: "${variantTitle}"`);
        log(`Quantity: ${item.quantity}`);
        log(`Key: ${item.key}`);

        // Variant title'dan beden çıkar - slash varsa her iki parçayı da kontrol et
        // Çünkü format "RENK / BEDEN" veya "BEDEN / RENK" veya "(XS-L) / RENK" olabilir
        const parts = variantTitle.split('/').map(p => p.trim().toUpperCase().replace(/[()]/g, '').trim());
        log(`Variant parts:`, parts);

        let sizeKey = null;

        // Önce normalized distribution'dan kontrol et - UZUNDAN KISAYA sırala (tire içeren bedenler / range isimleri önce)
        if (group.distribution && Object.keys(group.distribution).length > 0) {
          const sizes = Object.keys(group.distribution).sort((a, b) => b.length - a.length);
          log(`Checking against distribution (sorted):`, sizes);

          // Her variant part'ı kontrol et
          for (const variantPart of parts) {
            if (sizeKey) break; // Bulunduysa dur

            for (const size of sizes) {
              const sizeUpper = size.toUpperCase();

              // TAM EŞLEŞMEye öncelik ver (parantez temizlenmiş variant ile)
              if (variantPart === sizeUpper) {
                sizeKey = size;
                log(`✓ Size matched from distribution (exact): ${size} from part "${variantPart}"`);
                break;
              }

              // Tire içeren bedenler için kısmi eşleşme: "S-M" içinde "S" var mı?
              // (Beden Seti değilse — individual size eşleştirmesi)
              if (!group.isBedenSeti && sizeUpper.includes('-')) {
                const sizeParts = sizeUpper.split('-').map(s => s.trim());
                if (sizeParts.includes(variantPart)) {
                  sizeKey = size;
                  log(`✓ Size matched from distribution (partial in compound): ${size} contains ${variantPart}`);
                  break;
                }
              }
            }
          }
        }

        // Size option'lardan bul - UZUNDAN KISAYA
        if (!sizeKey) {
          const sizeOptions = ['XXXL', 'XXL', 'XL', 'L', 'M', 'S', 'XS'];
          log(`Checking against size options (sorted):`, sizeOptions);

          // Her variant part'ı kontrol et
          for (const variantPart of parts) {
            if (sizeKey) break; // Bulunduysa dur

            for (const size of sizeOptions) {
              if (variantPart === size || variantPart.startsWith(size + ' ') || variantPart === size) {
                sizeKey = size;
                log(`✓ Size matched from options: ${size} from part "${variantPart}"`);
                break;
              }
            }
          }
        }

        if (sizeKey) {
          const expectedQty = group.distribution?.[sizeKey] || 1;
          log(`✓ Adding to group: size=${sizeKey}, expected=${expectedQty}, current=${item.quantity}`);
          group.items.push({
            ...item,
            size: sizeKey,
            expectedQty: expectedQty,
            key: item.key
          });
        } else {
          log(`✗ Size NOT found for variant: "${variantTitle}"`);
        }
      } else {
        // Tek varyantlı set ürünler — renk bazlı (renk varsa)
        const variantTitleSV = item.variant_title || '';
        const scSV = extractSizeAndColor(variantTitleSV, null, false);
        const groupKeySV = makeGroupKey(handle, scSV.color);
        if (!setGroups.has(groupKeySV)) {
          setGroups.set(groupKeySV, {
            info: setInfo,
            handle: handle,
            color: scSV.color,
            items: [item],
            multiplier: setInfo.multiplier || 1
          });
        }
      }
    }
    
    log('Set grupları oluşturuldu:', setGroups);
    return setGroups;
  }

  // Komple set silme — atomik /cart/update.js + doğrulama pass'i
  // Aynı handle + aynı renk identity olan TÜM cart satırları tek seferde silinir
  async function removeCompleteSet(itemKey) {
    isUpdating = true;
    try {
      console.log('[Cart Set] removeCompleteSet START — itemKey:', itemKey);

      let cart = await fetch('/cart.js').then(r => r.json());
      const targetItem = cart.items.find(item => item.key === itemKey);
      if (!targetItem) {
        console.warn('[Cart Set] Target itemKey bulunamadı:', itemKey);
        return false;
      }

      const targetHandle = targetItem.handle || targetItem.url?.split('/products/')[1]?.split('?')[0];
      if (!targetHandle) {
        console.warn('[Cart Set] Handle bulunamadı:', targetItem);
        return false;
      }

      console.log('[Cart Set] Target handle:', targetHandle, '— variant_title:', targetItem.variant_title);

      const setInfo = await getProductSetInfo(targetHandle);
      if (!setInfo || !setInfo.isMultiSize) {
        console.log('[Cart Set] Set değil, tek satır siliniyor');
        const fd = new FormData();
        fd.append(`updates[${itemKey}]`, '0');
        await fetch('/cart/update.js', { method: 'POST', body: fd });
        return true;
      }

      // Distribution normalize
      let normalizedDistribution = {};
      let isBedenSeti = false;
      if (setInfo.distribution) {
        normalizedDistribution = setInfo.distribution;
      } else if (setInfo.distributions) {
        isBedenSeti = true;
        for (const [range, info] of Object.entries(setInfo.distributions)) {
          normalizedDistribution[range] = info.total || Object.values(info.sizes || {}).reduce((s, q) => s + q, 0);
        }
      }

      // Renk kimliği — önce variant_id+option bazlı (sağlam), olmuyorsa variant_title fallback
      const identifyColor = (ci) => {
        const byVariant = getVariantColorIdentity(ci.variant_id, setInfo, normalizedDistribution);
        if (byVariant) return byVariant;
        return extractSizeAndColor(ci.variant_title || '', normalizedDistribution, isBedenSeti).color;
      };

      const targetIdent = identifyColor(targetItem);
      console.log('[Cart Set] Target identity:', targetIdent, '— distribution:', normalizedDistribution);

      // Eşleşen satırları topla — handle + color identity
      const collectMatches = (cartObj) => {
        const out = [];
        for (const ci of (cartObj.items || [])) {
          const ciHandle = ci.handle || ci.url?.split('/products/')[1]?.split('?')[0];
          if (ciHandle !== targetHandle) continue;
          if (identifyColor(ci) === targetIdent) out.push(ci);
        }
        return out;
      };

      let matched = collectMatches(cart);
      if (matched.length === 0) matched = [targetItem];

      console.log('[Cart Set] Silinecek satır sayısı:', matched.length, '— variantlar:',
        matched.map(m => `${m.variant_title}(${String(m.key).substring(0,12)}...)`));

      // 1. PASS — atomik /cart/update.js (FormData)
      const fd = new FormData();
      for (const m of matched) fd.append(`updates[${m.key}]`, '0');
      try {
        const resp = await fetch('/cart/update.js', { method: 'POST', body: fd });
        console.log('[Cart Set] /cart/update.js → status:', resp.status);
      } catch (err) {
        console.error('[Cart Set] /cart/update.js hatası:', err);
      }

      // DOĞRULAMA — kalan var mı?
      cart = await fetch('/cart.js').then(r => r.json());
      let stragglers = collectMatches(cart);

      // 2. PASS — kalan varsa sıralı /cart/change.js ile temizle
      if (stragglers.length > 0) {
        console.warn('[Cart Set] Cleanup pass — kalan:', stragglers.length, 'satır');
        for (const s of stragglers) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: s.key, quantity: 0 })
            });
          } catch (err) {
            console.error('[Cart Set] cleanup change.js hatası:', err);
          }
        }
        cart = await fetch('/cart.js').then(r => r.json());
        stragglers = collectMatches(cart);
      }

      // 3. PASS — hâlâ kalan varsa son çare: handle bazlı zorla sil
      if (stragglers.length > 0) {
        console.warn('[Cart Set] Final pass — handle bazlı zorla:', stragglers.length, 'satır');
        for (const s of stragglers) {
          try {
            const fd2 = new FormData();
            fd2.append(`updates[${s.key}]`, '0');
            await fetch('/cart/update.js', { method: 'POST', body: fd2 });
          } catch (err) {
            console.error('[Cart Set] final pass hatası:', err);
          }
        }
        cart = await fetch('/cart.js').then(r => r.json());
        stragglers = collectMatches(cart);
      }

      if (stragglers.length > 0) {
        showNotification(T('cartUpdating'), 'warning');
        setTimeout(() => window.location.reload(), 1200);
        return false;
      }

      showNotification(T('setRemoved'), 'success');
      await refreshCart();
      return true;

    } catch (error) {
      console.error('[Cart Set] removeCompleteSet HATA:', error, error?.stack);
      showNotification(T('errorReloading'), 'warning');
      setTimeout(() => window.location.reload(), 1500);
      return false;
    } finally {
      isUpdating = false;
    }
  }

  // Kaldır linklerini ve butonlarını intercept et — set ürünü ise tüm bedenleri sil
  function interceptRemoveLinks() {
    // Hem <a> linklerini hem de tema'nın <button data-cart-remove> butonlarını yakala
    const removeTargets = document.querySelectorAll(
      'a[href*="/cart/change"][href*="quantity=0"], a[aria-label*="kaldır"], a[aria-label*="Kaldır"], .cart-remove, .remove-item, button[data-cart-remove], [data-cart-remove]'
    );

    removeTargets.forEach(target => {
      if (target.dataset.intercepted) return;
      target.dataset.intercepted = 'true';

      const handler = async (e) => {
        // STRATEJI: Capture phase'te yakaladığımızda HEMEN preventDefault yap, sonra
        // taze cart.js fetch ile set olup olmadığını kontrol et. Set değilse manuel
        // olarak tema'nın silme işlemini taklit et (tek satır sil).

        const cartItem = target.closest('[data-cart-line], [data-cart-item], .cart-item, .cart__item, line-item, tr[data-product-id]');
        if (!cartItem) return;

        const handle = getHandleFromItem(cartItem);

        // Item key'i bul — cartItem.dataset.id KULLANMA (variant_id, line key DEĞİL)
        let itemKey = target.dataset.lineKey || target.dataset.cartItemKey || cartItem.dataset.lineKey || null;
        if (!itemKey) {
          const href = target.href || target.getAttribute('href');
          if (href) {
            const m = href.match(/[?&]id=([^&]+)/);
            if (m) itemKey = m[1];
          }
        }
        if (!itemKey) {
          const qi = cartItem.querySelector('input[name*="updates"]');
          if (qi) {
            const m = qi.name.match(/updates\[([^\]]+)\]/);
            if (m) itemKey = m[1];
          }
        }
        // Tema'nın <button data-cart-remove data-line="..."> formatı: line index
        const lineIndex = target.dataset.line || cartItem.dataset.cartLine;

        if (!handle && !itemKey && !lineIndex) return; // Hiçbir bilgi yoksa dokunma

        // Capture phase'te tema handler'ından önce yakala
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Taze cart fetch — cache'e güvenme
        let isSetItem = false;
        let setHandleResolved = handle;
        let cartItemFromAPI = null;
        try {
          const cart = await fetch('/cart.js').then(r => r.json());
          if (itemKey) {
            cartItemFromAPI = cart.items.find(i => i.key === itemKey);
          } else if (lineIndex) {
            cartItemFromAPI = cart.items[parseInt(lineIndex, 10) - 1];
            if (cartItemFromAPI) itemKey = cartItemFromAPI.key;
          }
          if (cartItemFromAPI) {
            setHandleResolved = cartItemFromAPI.handle || setHandleResolved;
            const setInfo = setHandleResolved ? await getProductSetInfo(setHandleResolved) : null;
            if (setInfo && setInfo.isMultiSize) {
              isSetItem = true;
              await groupSetItems();
            }
          }
        } catch (err) {
          log('Kaldır click set kontrolü başarısız:', err);
        }

        if (isSetItem && itemKey) {
          log('Set kaldır tıklandı:', setHandleResolved, 'itemKey:', itemKey);
          const success = await removeCompleteSet(itemKey);
          if (success) await refreshCart();
        } else if (itemKey) {
          // Set değil — tek satırı sil (tema handler'ını manuel taklit)
          log('Set değil, tek satır siliniyor:', itemKey);
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemKey, quantity: 0 })
            });
            await refreshCart();
          } catch (err) {
            log('Tek satır silme hatası:', err);
            // Son çare: sayfayı yenile
            window.location.reload();
          }
        } else {
          log('Item key tespit edilemedi — sayfa yenileniyor');
          window.location.reload();
        }
      };

      // CAPTURE phase: tema'nın bubble phase handler'ından ÖNCE çalışsın
      target.addEventListener('click', handler, true);
    });
  }
  
  // Multi-size set için tüm bedenleri güncelle (groupKey: composite handle::color)
  // Lot bazlı güncelleme — operation: 'increase' | 'decrease' | <sayı> (hedef lot sayısı)
  async function updateMultiSizeSet(groupKey, operation) {
    if (isUpdating) {
      log('Update already in progress, skipping');
      return;
    }

    const group = setGroups.get(groupKey);
    if (!group || !group.info.isMultiSize) return;

    log('=== UPDATE MULTI-SIZE SET (lot) ===', groupKey, 'op:', operation);

    const { lots, sizeVariantMap, maxLots, hasTrustworthyStock } = computeGroupLots(group);
    if (!hasTrustworthyStock || lots.length === 0) {
      log('Lot hesaplanamadı (stok verisi yok), işlem iptal');
      return;
    }

    // Sepetteki size→qty
    const cartBySize = {};
    for (const item of group.items) {
      if (item.size) cartBySize[item.size] = (cartBySize[item.size] || 0) + (item.quantity || 0);
    }
    const currentN = matchLotCount(cartBySize, lots);
    log(`Lot durumu — currentN: ${currentN}, maxLots: ${maxLots}`);

    let newN;
    if (operation === 'increase') newN = currentN + 1;
    else if (operation === 'decrease') newN = currentN - 1;
    else newN = Math.max(0, parseInt(operation) || 0);
    log('Hedef lot sayısı:', newN);

    // 0 → tüm seti sil (atomik 3-pass cleanup)
    if (newN <= 0 && group.items && group.items.length > 0) {
      log('newN<=0 → removeCompleteSet');
      await removeCompleteSet(group.items[0].key);
      return;
    }

    // Max lot aşımı
    if (newN > maxLots) {
      log(`Max lot aşıldı: ${newN} > ${maxLots}`);
      showCartMaxNotification(maxLots);
      for (const item of group.items) {
        try {
          const inp = document.querySelector(`input[data-line-key="${item.key}"]`);
          if (inp) inp.value = String(currentN);
        } catch (_) {}
      }
      return;
    }

    isUpdating = true;
    try {
      const union = mergeLotsUnion(lots, newN);
      log('Hedef birleşim:', union);
      await applyLotTarget(group, sizeVariantMap, union);
      showNotification(`<strong>${escapeText(group.info.title)}</strong> · ${newN} lot`, 'success');
      await refreshCart();
    } catch (e) {
      console.error('[Cart Set] updateMultiSizeSet hata:', e);
      showNotification(T('lotUpdateError'), 'warning');
    } finally {
      isUpdating = false;
    }
  }
  
  // Eksik varyantları sepete ekle
  async function addMissingVariants(handle, group, sets) {
    if (sets === 0) return;
    
    const existingSizes = group.items.map(item => item.size);
    const missingSizes = Object.keys(group.distribution).filter(size => !existingSizes.includes(size));
    
    if (missingSizes.length === 0) return;
    
    log('Eksik bedenler bulundu:', missingSizes);
    
    try {
      const product = await fetch(`/products/${handle}.js`).then(r => r.json());
      
      for (const size of missingSizes) {
        // İlgili varyantı bul
        const variant = product.variants.find(v => {
          const title = (v.title || '').toUpperCase();
          return title.includes(size) || v.option1 === size || v.option2 === size || v.option3 === size;
        });

        if (!variant || !variant.available) continue;

        const qty = group.distribution[size] * sets;

        // Stok yetiyor mu? Sadece güvenilir stok bilgisi varsa kontrol et
        if (variant.inventory_management === 'shopify' &&
            variant.inventory_policy !== 'continue' &&
            typeof variant.inventory_quantity === 'number' &&
            variant.inventory_quantity < qty) {
          log(`Eksik beden eklenmedi (stok yetersiz): ${size} — istenen=${qty}, stok=${variant.inventory_quantity}`);
          continue;
        }

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variant.id, quantity: qty })
          });
          log(`Eksik beden eklendi: ${size} - ${qty} adet`);
        } catch (err) {
          log(`Eksik beden ekleme hatası (${size}):`, err);
        }
      }
      
      // Grupları yenile
      await groupSetItems();
    } catch (error) {
      log('Eksik varyant ekleme hatası:', error);
    }
  }
  
  // Toplu sepet güncellemesi — atomik FormData /cart/update.js
  // Tek istek = tüm line key'ler aynı transaction'da, paralel race yok
  async function batchUpdateCart(updates) {
    if (Object.keys(updates).length === 0) return;

    isUpdating = true;

    try {
      const fd = new FormData();
      for (const [key, qty] of Object.entries(updates)) {
        fd.append(`updates[${key}]`, String(qty));
      }
      const response = await fetch('/cart/update.js', { method: 'POST', body: fd });
      log(`batchUpdateCart /cart/update.js → status: ${response.status}`);

      if (!response.ok) {
        // Fallback: satır bazlı sıralı /cart/change.js
        log('Fallback: sıralı /cart/change.js denenecek');
        for (const [key, qty] of Object.entries(updates)) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: qty })
            });
          } catch (err) {
            log('Fallback change.js hatası:', err);
          }
        }
      }

      await refreshCart();
    } catch (error) {
      console.error('[Cart Set] Toplu güncelleme hatası:', error);
    } finally {
      isUpdating = false;
    }
  }
  
  // Sepet sayfası kontrollerini ayarla
  async function setupCartPageControls() {
    if (!document.querySelector('cart-items')) return;

    await groupSetItems();

    // Otomatik düzeltme — stok-üstü setleri sayfa açılınca düşür (sadece ilk yüklemede)
    // batchUpdateCart sayfayı yeniler, böylece kullanıcı düzeltilmiş hâli görür
    const corrected = await autoCorrectOverstockSets();
    if (corrected) return; // Sayfa yenilenecek, devam etme

    // Cart API'den variant_id → group key haritası oluştur — DOM'dan renk parse etmek yerine
    let variantToGroupKey = new Map();
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      if (cart && cart.items) {
        for (const ci of cart.items) {
          // Bu item hangi group'a ait? Tüm group'ları tarayıp items'ında key eşleşeni bul
          for (const [gKey, gVal] of setGroups.entries()) {
            if ((gVal.items || []).some(it => it.key === ci.key)) {
              variantToGroupKey.set(ci.variant_id, gKey);
              break;
            }
          }
        }
      }
    } catch (e) {
      log('variantToGroupKey haritası oluşturulamadı:', e);
    }

    // Farklı tema yapılarını destekle
    const cartItems = document.querySelectorAll('line-item, [data-cart-item], .cart-item, .cart__item, .line-item, tr[data-product-id]');

    log(`Cart items found: ${cartItems.length}`);

    // Multi-size setler için: aynı (handle+renk) grubunun yalnızca İLK DOM item'ı "ana" olarak gösterilir,
    // diğerleri görsel olarak gizlenir (set tek satır halinde sunulur).
    const multiSizeMainSelected = new Set();

    for (const item of cartItems) {
      const handle = getHandleFromItem(item);
      if (!handle) continue;

      // Composite group key — DOM variant_id ile haritadan bul
      const variantId = parseInt(item.dataset.id || '0', 10);
      let groupKey = variantId ? variantToGroupKey.get(variantId) : null;
      if (!groupKey) continue;

      const group = setGroups.get(groupKey);
      if (!group) continue;

      // Multi-size setler için (Beden Seti ve Multi-size distribution)
      if (group.info.isMultiSize) {
        if (!multiSizeMainSelected.has(groupKey)) {
          // Ana satır
          multiSizeMainSelected.add(groupKey);
          item.style.display = '';
          item.removeAttribute('data-wholesale-hidden');
          setupMultiSizeControls(item, groupKey, group);
          renderSetSummaryOnMain(item, group);
        } else {
          // Set'in diğer beden satırları — gizle
          item.style.display = 'none';
          item.setAttribute('data-wholesale-hidden', 'true');
        }
      }
      // Tek varyantlı setler için (STD, Paket Yapısı, Title-based)
      else if (group.info.multiplier && group.info.multiplier > 1) {
        setupSingleVariantControls(item, groupKey, group);
        renderSingleVariantSummary(item, group, group.info.multiplier);
      }
      // Multiplier tanımlı ama 1'e eşit olan durumlar için de kontrol ekle
      else if (group.multiplier && group.multiplier > 1) {
        setupSingleVariantControls(item, groupKey, group);
        renderSingleVariantSummary(item, group, group.multiplier);
      }
    }

    // Kaldır linklerini intercept et - YENİ!
    interceptRemoveLinks();
  }

  // Multi-size set'in ana satırına tema-uyumlu özet bilgisi yaz
  function renderSetSummaryOnMain(item, group) {
    try {
      // Çift render'ı önle
      if (item.querySelector('.cart-item__wholesale-set')) return;

      // Lot listesi + mevcut lot sayısı
      const { lots, maxLots, hasTrustworthyStock } = computeGroupLots(group);
      const cartBySize = {};
      for (const it of group.items) {
        if (it.size) cartBySize[it.size] = (cartBySize[it.size] || 0) + (it.quantity || 0);
      }
      const currentN = lots.length ? matchLotCount(cartBySize, lots) : 1;

      // Toplam fiyat ve adet
      const totalCents = group.items.reduce((sum, i) => sum + (Number(i.line_price) || 0), 0);
      const totalQty = group.items.reduce((sum, i) => sum + (Number(i.quantity) || 0), 0);

      // Para birimini mevcut fiyat etiketinden çıkar
      let currency = 'TRY';
      const priceEl = item.querySelector('.cart-item__line-price, price-list, sale-price, .price, .cart-item__price, .line-item__price');
      if (priceEl) {
        const m = priceEl.textContent.match(/[A-Z]{3}/);
        if (m) currency = m[0];
      }

      const totalFormatted = (totalCents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + currency;

      // Ana satırın fiyatını TOPLAM ile değiştir
      if (priceEl) {
        const totalSpan = priceEl.querySelector('span:not(.cart-item__original-price):not(.cart-item__unit-price)') || priceEl;
        totalSpan.textContent = totalFormatted;
        priceEl.setAttribute('data-wholesale-set-total', '1');
      }

      // Set İçeriği etiketi — Set İçerik Bilgisi dağılımı (her lot için)
      const idealDist = group.distribution || {};
      const idealText = Object.entries(idealDist)
        .map(([s, q]) => `${escapeText(s)}×${q}`).join(' · ');

      const summaryEl = document.createElement('div');
      summaryEl.className = 'cart-item__wholesale-set mt-2 text-xs space-y-0.5';
      summaryEl.innerHTML = `
        <div class="flex items-center gap-1.5 opacity-80 font-medium uppercase tracking-wide">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          <span>${T('setProductBadge')} · ${currentN} ${T('lotsUnit')}</span>
        </div>
        <div class="opacity-65"><span class="font-medium">${T('setContents')}</span> ${idealText}</div>
        <div class="opacity-65">${T('total', totalQty)}</div>
      `;

      // Variant satırından sonra (yoksa title'dan sonra) yerleştir
      const variantEl = item.querySelector('.cart-item__variant');
      const titleEl = item.querySelector('.cart-item__title, h3, h4');
      const insertAfter = variantEl || titleEl;
      if (insertAfter && insertAfter.parentNode) {
        insertAfter.parentNode.insertBefore(summaryEl, insertAfter.nextSibling);
      } else {
        item.appendChild(summaryEl);
      }

      // Quantity input'una LOT SAYISI yaz
      const qtyInput = item.querySelector('input[name*="updates"], input.quantity-selector__input, input.quantity__input, input[type="number"]');
      if (qtyInput) {
        qtyInput.value = currentN;
        qtyInput.setAttribute('readonly', 'readonly');
        qtyInput.setAttribute('data-wholesale-set-display', '1');
        qtyInput.style.textAlign = 'center';
        qtyInput.style.cursor = 'default';
        // min=0: tema'nın <quantity-input> component'i value<=min ise minus'u disable ediyor.
        // Son lotu silebilmek için minus value=1'de bile aktif olmalı.
        qtyInput.setAttribute('min', '0');
        qtyInput.min = '0';
      }

      // Minus butonu force-enable (tema otomatik disable ediyor; biz lot silebilelim diye açıyoruz)
      const minusBtn = item.querySelector('button[name="minus"]');
      if (minusBtn) {
        minusBtn.disabled = false;
        minusBtn.removeAttribute('disabled');
        minusBtn.classList.remove('disabled');
      }

      // Plus butonu: max lota vurulduysa görsel disable (intercept zaten engelliyor; UI feedback)
      const plusBtn = item.querySelector('button[name="plus"]');
      if (plusBtn) {
        if (hasTrustworthyStock && currentN >= maxLots) {
          plusBtn.disabled = true;
          plusBtn.classList.add('disabled');
          plusBtn.title = `Maksimum ${maxLots} lot (stok)`;
        } else {
          plusBtn.disabled = false;
          plusBtn.classList.remove('disabled');
          plusBtn.removeAttribute('title');
        }
      }

      // Variant text'i sadeleştir: "Lacivert - L" → "Lacivert" (set olduğu için beden gösterme)
      if (variantEl && !variantEl.dataset.wholesaleVariantSimplified) {
        // group.color içerik yapısı: 'LACIVERT' veya 'LACIVERT|...' gibi pipe-separated
        const colorClean = (group.color || '').replace(/\|/g, ' ').replace('_default', '').trim();
        if (colorClean) {
          // Title-case dönüşüm (LACIVERT → Lacivert)
          const titleCased = colorClean.split(/\s+/).map(w => w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w).join(' ');
          variantEl.textContent = titleCased;
        } else {
          variantEl.textContent = '';
        }
        variantEl.dataset.wholesaleVariantSimplified = '1';
      }
    } catch (err) {
      log('renderSetSummaryOnMain error:', err);
    }
  }

  function escapeText(str) {
    return String(str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }
  
  // Multi-size set kontrolleri
  function setupMultiSizeControls(item, handle, group) {
    // Zaten kurulmuşsa skip et (duplicate önleme)
    if (item.dataset.setControlsAttached === 'true') {
      log(`Multi-size controls already attached, skipping setup for ${handle}`);
      return;
    }

    log(`=== Setup Multi-Size Controls for ${handle} ===`);

    const quantityInput = item.querySelector('input[name*="updates"], input.quantity-selector__input, input.quantity__input, input[type="number"]');
    log(`Quantity input found:`, quantityInput !== null);

    if (!quantityInput) {
      log(`⚠️ No quantity input found, skipping`);
      return;
    }

    // Parent row'u bul (table yapısında desktop button'lar başka td'de olabilir)
    const parentRow = item.closest('tr');
    const searchScope = parentRow || item; // Row varsa row'da ara, yoksa item'da
    log(`Search scope:`, parentRow ? 'table row' : 'line-item');

    // TÜM button'ları bul (mobile + desktop için - row içindeki TÜM button'lar)
    const allButtons = searchScope.querySelectorAll('.quantity-selector__button, [name="plus"], [name="minus"], .quantity__button');
    log(`All buttons found: ${allButtons.length}`);

    // Plus ve minus button'ları ayır
    const plusButtons = [];
    const minusButtons = [];

    allButtons.forEach((btn, index) => {
      const ariaLabel = btn.getAttribute('aria-label') || '';
      const html = btn.innerHTML || '';

      // Plus button mu kontrol et (çift sayılı indexler genelde plus)
      if (index % 2 === 1 || html.includes('icon-plus') || ariaLabel.toLowerCase().includes('artır') || ariaLabel.toLowerCase().includes('increase')) {
        plusButtons.push(btn);
      }
      // Minus button
      else if (index % 2 === 0 || html.includes('icon-minus') || ariaLabel.toLowerCase().includes('azalt') || ariaLabel.toLowerCase().includes('decrease')) {
        minusButtons.push(btn);
      }
    });

    log(`Plus buttons: ${plusButtons.length}, Minus buttons: ${minusButtons.length}`);

    // TÜM Plus button'lara handler ekle
    plusButtons.forEach((plusBtn, idx) => {
      // href'i disable et
      if (plusBtn.getAttribute('href')) {
        plusBtn.dataset.originalHref = plusBtn.getAttribute('href');
        plusBtn.setAttribute('href', 'javascript:void(0)');
        log(`Plus button ${idx} href disabled`);
      }

      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        log(`Plus button ${idx} clicked for multi-size ${handle}`);
        // Debounce: hızlı tıklamaları birleştir (300ms)
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => updateMultiSizeSet(handle, 'increase'), 300);
      }, { capture: true });
      log(`✓ Plus button ${idx} handler attached (capture mode)`);
    });

    // TÜM Minus button'lara handler ekle
    minusButtons.forEach((minusBtn, idx) => {
      // href'i disable et
      if (minusBtn.getAttribute('href')) {
        minusBtn.dataset.originalHref = minusBtn.getAttribute('href');
        minusBtn.setAttribute('href', 'javascript:void(0)');
        log(`Minus button ${idx} href disabled`);
      }

      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        log(`Minus button ${idx} clicked for multi-size ${handle}`);
        // Debounce: hızlı tıklamaları birleştir (300ms)
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => updateMultiSizeSet(handle, 'decrease'), 300);
      }, { capture: true });
      log(`✓ Minus button ${idx} handler attached (capture mode)`);
    });
    
    // Input değişikliği — debounce ile
    quantityInput.addEventListener('change', (e) => {
      const itemKey = quantityInput.dataset.lineKey || quantityInput.getAttribute('data-line-key');
      const cartItem = group.items.find(i => i.key === itemKey);

      if (cartItem) {
        const value = parseInt(e.target.value) || 0;
        // Toplam adet bazlı hesaplama (tek varyant düşürüldüğünde tüm set silinmesin)
        const sets = Math.max(value > 0 ? 1 : 0, Math.round(value / cartItem.expectedQty));
        log(`Input change: value=${value}, expectedQty=${cartItem.expectedQty}, sets=${sets}`);
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => updateMultiSizeSet(handle, sets), 300);
      }
    });

    log(`✓ Multi-size controls setup completed for ${handle}`);
    // İşlem tamamlandı, flag'i set et
    item.dataset.setControlsAttached = 'true';
  }
  
  // Tek varyantlı set kontrolleri
  function setupSingleVariantControls(item, handle, group) {
    // Zaten kurulmuşsa skip et (duplicate önleme)
    if (item.dataset.setControlsAttached === 'true') {
      log(`Controls already attached, skipping setup for ${handle}`);
      return;
    }

    log(`=== Setup Single Variant Controls for ${handle} ===`);

    const quantityInput = item.querySelector('input[name*="updates"], input.quantity-selector__input, input.quantity__input, input[type="number"]');
    log(`Quantity input found:`, quantityInput !== null);

    // Parent row'u bul (table yapısında desktop button'lar başka td'de olabilir)
    const parentRow = item.closest('tr');
    const searchScope = parentRow || item; // Row varsa row'da ara, yoksa item'da
    log(`Search scope:`, parentRow ? 'table row' : 'line-item');

    // TÜM button'ları bul (mobile + desktop için - row içindeki TÜM button'lar)
    const allButtons = searchScope.querySelectorAll('.quantity-selector__button, [name="plus"], [name="minus"], .quantity__button');
    log(`All buttons found: ${allButtons.length}`);

    // Plus ve minus button'ları ayır
    const plusButtons = [];
    const minusButtons = [];

    allButtons.forEach((btn, index) => {
      const ariaLabel = btn.getAttribute('aria-label') || '';
      const html = btn.innerHTML || '';

      // Plus button mu kontrol et (çift sayılı indexler genelde plus)
      if (index % 2 === 1 || html.includes('icon-plus') || ariaLabel.toLowerCase().includes('artır') || ariaLabel.toLowerCase().includes('increase')) {
        plusButtons.push(btn);
      }
      // Minus button
      else if (index % 2 === 0 || html.includes('icon-minus') || ariaLabel.toLowerCase().includes('azalt') || ariaLabel.toLowerCase().includes('decrease')) {
        minusButtons.push(btn);
      }
    });

    log(`Plus buttons: ${plusButtons.length}, Minus buttons: ${minusButtons.length}`);

    if (!quantityInput) {
      log(`⚠️ No quantity input found, skipping`);
      return;
    }

    // Multiplier'ı güvenli şekilde al - group.info.multiplier veya group.multiplier
    const multiplier = group.info.multiplier || group.multiplier || 1;

    // Eğer multiplier 1 ise, set ürünü değildir, kontrol eklemeye gerek yok
    if (multiplier <= 1) {
      log(`Multiplier is 1, skipping set controls`);
      return;
    }

    log(`✓ Setting up controls with multiplier: ${multiplier}`);

    // Cart satir anahtari: DOM'da data-line-key YOK (bu temada data-line var) —
    // guvenilir kaynak cart.js'ten gelen group.items[0].key. Fallback: variant id
    // (/cart/update.js variant_id anahtarini da kabul eder).
    const lineKey = (group.items && group.items[0] && group.items[0].key)
      || quantityInput.dataset.lineKey
      || quantityInput.getAttribute('data-line-key')
      || quantityInput.dataset.quantityVariantId
      || quantityInput.getAttribute('data-quantity-variant-id');
    log(`Line key resolved: ${lineKey}`);
    if (!lineKey) {
      log(`⚠️ Line key bulunamadi — kontroller kurulamiyor`);
      return;
    }

    // Adet kutusu LOT SAYISI gosterir (birim adet degil): 6 birim / 6'li set = 1.
    // Kullanici karari (16.07.2026): "1 set ekledim 6 yaziyor" karisikligini onler.
    const unitsNow = parseInt(quantityInput.value) || 0;
    const lotsNow = Math.max(1, Math.round(unitsNow / multiplier));
    quantityInput.value = lotsNow;
    quantityInput.setAttribute('readonly', 'readonly');
    quantityInput.setAttribute('data-wholesale-set-display', '1');
    quantityInput.style.textAlign = 'center';
    quantityInput.style.cursor = 'default';
    quantityInput.setAttribute('min', '0');
    quantityInput.min = '0';

    // (Auto-adjust kaldırıldı — sayfa yüklenince kullanıcı bilgisi olmadan cart'ı değiştirme)

    // TÜM Plus button'lara handler ekle (mobile + desktop)
    plusButtons.forEach((plusBtn, idx) => {
      // href'i disable et (sayfayı yönlendirmemesi için)
      if (plusBtn.getAttribute('href')) {
        plusBtn.dataset.originalHref = plusBtn.getAttribute('href');
        plusBtn.setAttribute('href', 'javascript:void(0)');
        log(`Plus button ${idx} href disabled`);
      }

      plusBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Diğer handler'ları durdur!
        log(`Plus button clicked for ${handle}`);
        // Input LOT gosterir — birim adede cevirerek gonder
        const currentLots = parseInt(quantityInput.value) || 0;
        const newLots = currentLots + 1;
        quantityInput.value = newLots;

        log(`Updating with line key: ${lineKey}, lots: ${newLots} -> units: ${newLots * multiplier}`);
        await updateSingleItem(lineKey, newLots * multiplier);
        showNotification(`+${multiplier} adet (1 set) eklendi`, 'success');
      }, { capture: true }); // CAPTURE PHASE - erken yakala!
      log(`✓ Plus button ${idx} handler attached (capture mode)`);
    });

    if (plusButtons.length === 0) {
      log(`⚠️ No plus buttons found`);
    }

    // TÜM Minus button'lara handler ekle (mobile + desktop)
    minusButtons.forEach((minusBtn, idx) => {
      // href'i disable et
      if (minusBtn.getAttribute('href')) {
        minusBtn.dataset.originalHref = minusBtn.getAttribute('href');
        minusBtn.setAttribute('href', 'javascript:void(0)');
        log(`Minus button ${idx} href disabled`);
      }

      minusBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Diğer handler'ları durdur!
        log(`Minus button clicked for ${handle}`);
        // Input LOT gosterir — birim adede cevirerek gonder
        const currentLots = parseInt(quantityInput.value) || 0;
        const newLots = Math.max(0, currentLots - 1);
        quantityInput.value = newLots;

        log(`Updating with line key: ${lineKey}, lots: ${newLots} -> units: ${newLots * multiplier}`);
        await updateSingleItem(lineKey, newLots * multiplier);
        if (newLots > 0) {
          showNotification(T('removedFromCart', multiplier), 'info');
        }
      }, { capture: true }); // CAPTURE PHASE - erken yakala!
      log(`✓ Minus button ${idx} handler attached (capture mode)`);
    });

    if (minusButtons.length === 0) {
      log(`⚠️ No minus buttons found`);
    }

    // İşlem tamamlandı, flag'i set et
    item.dataset.setControlsAttached = 'true';
    log(`✓ Controls setup completed for ${handle}`);
  }
  
  // Tek item güncelleme
  async function updateSingleItem(key, quantity) {
    // Eğer key "updates[...]" formatındaysa temizle
    // Değilse direkt lineKey olarak kullan (data-line-key'den gelen format)
    let lineKey = key;
    if (key && key.includes('updates[')) {
      lineKey = key.replace('updates[', '').replace(']', '');
    }

    log(`updateSingleItem: lineKey=${lineKey}, quantity=${quantity}`);
    const updates = { [lineKey]: quantity };
    await batchUpdateCart(updates);
  }
  
  // Tek varyant (STD) set: baslik altina duz metin ozeti — arka plan/rozet YOK
  // (kullanici karari 16.07.2026). Adet kutusu LOT sayisini gosterir; birim
  // adet "Toplam" satirinda verilir. Multi-size'daki renderSetSummaryOnMain
  // ile ayni gorsel dil.
  function renderSingleVariantSummary(item, group, multiplier) {
    try {
      if (item.querySelector('.cart-item__wholesale-set')) return;

      const cartItem = (group.items && group.items[0]) || {};
      const totalQty = Number(cartItem.quantity) || multiplier;
      const lots = Math.max(1, Math.round(totalQty / multiplier));
      const sizeLabel = cartItem.size ? escapeText(cartItem.size) : 'STD';

      const summaryEl = document.createElement('div');
      summaryEl.className = 'cart-item__wholesale-set mt-2 text-xs space-y-0.5';
      summaryEl.innerHTML = `
        <div class="flex items-center gap-1.5 opacity-80 font-medium uppercase tracking-wide">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          <span>${T('setProductBadge')} · ${lots} ${T('lotsUnit')}</span>
        </div>
        <div class="opacity-65"><span class="font-medium">${T('setContents')}</span> ${sizeLabel}×${multiplier}</div>
        <div class="opacity-65">${T('total', totalQty)}</div>
      `;

      const variantEl = item.querySelector('.cart-item__variant');
      const titleEl = item.querySelector('.cart-item__title, h3, h4');
      const insertAfter = variantEl || titleEl;
      if (insertAfter && insertAfter.parentNode) {
        insertAfter.parentNode.insertBefore(summaryEl, insertAfter.nextSibling);
      } else {
        item.appendChild(summaryEl);
      }
    } catch (err) {
      log('renderSingleVariantSummary error:', err);
    }
  }

  // Multi-size badge
  function addMultiSizeBadge(item, group) {
    if (item.querySelector('.multi-size-badge')) return;
    
    // Tasarim karari (16.07.2026): renk/gradient YOK — duz siyah zemin + beyaz
    // yazi, animasyonsuz, minimal (BLACK marka diline uygun).
    const badge = document.createElement('div');
    badge.className = 'multi-size-badge';
    badge.style.cssText = `
      background: #000;
      color: #fff;
      padding: 5px 12px;
      border-radius: 2px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      margin: 8px 0;
      display: inline-flex;
      align-items: center;
      gap: 8px;
    `;

    // XSS koruması: kullanıcı verisini escape et
    const escapeHtml = (str) => str.replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const distribution = group.items.map(i => `${escapeHtml(i.size)}-${i.expectedQty}`).join(' ');

    badge.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
      </svg>
      <span>Set: ${distribution}</span>
    `;
    
    // Single-variant badge ile aynı strateji - farklı tema yapıları için price element bul
    const priceEl = item.querySelector('price-list, .price-list, sale-price, .price, .cart-item__price, .line-item__price');
    if (priceEl) {
      priceEl.parentNode.insertBefore(badge, priceEl);
      log(`✓ Multi-size badge added before price element`);
    } else {
      // Fallback: item'ın başına ekle
      const itemInfo = item.querySelector('.line-item-info, .cart-item__details, .v-stack');
      if (itemInfo) {
        itemInfo.insertBefore(badge, itemInfo.firstChild);
        log(`✓ Multi-size badge added to item info`);
      } else {
        item.appendChild(badge);
        log(`✓ Multi-size badge appended to item`);
      }
    }
  }
  
  // Tek varyant badge
  function addSingleVariantBadge(item, multiplier) {
    if (item.querySelector('.single-variant-badge')) {
      log(`Badge already exists, skipping`);
      return;
    }

    log(`Adding badge for multiplier: ${multiplier}`);

    // Tasarim karari (16.07.2026): renk/gradient/emoji YOK — duz siyah zemin +
    // beyaz yazi, grid ikonu (theme copy'lerdeki rozet icerigi, monokrom).
    const badge = document.createElement('div');
    badge.className = 'single-variant-badge';
    badge.style.cssText = `
      background: #000;
      color: #fff;
      padding: 5px 12px;
      border-radius: 2px;
      font-size: 11px;
      font-weight: 600;
      letter-spacing: 0.08em;
      text-transform: uppercase;
      margin: 5px 0;
      display: inline-flex;
      align-items: center;
      gap: 6px;
    `;

    badge.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <rect x="3" y="3" width="7" height="7"></rect>
        <rect x="14" y="3" width="7" height="7"></rect>
        <rect x="14" y="14" width="7" height="7"></rect>
        <rect x="3" y="14" width="7" height="7"></rect>
      </svg>
      <span>${multiplier}'li Set</span>
    `;

    // Farklı tema yapıları için price element bul
    const priceEl = item.querySelector('price-list, .price-list, sale-price, .price, .cart-item__price, .line-item__price');
    if (priceEl) {
      priceEl.parentNode.insertBefore(badge, priceEl);
      log(`✓ Badge added before price element`);
    } else {
      // Fallback: item'ın başına ekle
      const itemInfo = item.querySelector('.line-item-info, .cart-item__details, .v-stack');
      if (itemInfo) {
        itemInfo.insertBefore(badge, itemInfo.firstChild);
        log(`✓ Badge added to item info`);
      } else {
        item.appendChild(badge);
        log(`✓ Badge appended to item`);
      }
    }
  }
  
  // Handle'ı al
  function getHandleFromItem(item) {
    const link = item.querySelector('a[href*="/products/"]');
    if (link) {
      const url = link.href || link.getAttribute('href');
      const match = url.match(/\/products\/([^?#]+)/);
      if (match) return match[1];
    }
    return null;
  }
  
  // Sepeti yenile
  async function refreshCart() {
    try {
      const cartDrawer = document.querySelector('cart-drawer, .cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.refresh === 'function') {
          cartDrawer.refresh();
        } else if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }

      if (window.location && window.location.pathname && window.location.pathname.includes('/cart')) {
        setTimeout(() => {
          if (window.location && window.location.reload) {
            window.location.reload();
          }
        }, 500);
      }

      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const cart = await response.json();

      if (cart && cart.item_count !== undefined) {
        const itemCount = cart.item_count || 0;
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(el => {
          if (el && el.textContent !== undefined) {
            el.textContent = itemCount;
          }
        });
      }
    } catch (error) {
      console.error('[Cart Set] Error refreshing cart:', error.message || error);
    }
  }
  
  // Mini sepet interceptor
  function interceptMiniCart() {
    const originalFetch = window.fetch;
    
    window.fetch = async function(url, options = {}) {
      const urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      if ((urlStr.includes('/cart/change') || urlStr.includes('/cart/update')) && !isUpdating) {
        
        try {
          const body = options.body;
          let lineKey, requestedQty;
          
          if (body instanceof FormData) {
            lineKey = body.get('id');
            requestedQty = parseInt(body.get('quantity')) || 0;
          } else if (typeof body === 'string') {
            const json = JSON.parse(body);
            lineKey = json.id;
            requestedQty = json.quantity;
          }
          
          const cart = await originalFetch('/cart.js').then(r => r.json());
          const cartItem = cart.items.find(i => i.key === lineKey);
          
          if (cartItem) {
            await groupSetItems();

            // setGroups'ı tarayıp lineKey'in bulunduğu (handle+renk) grubu bul
            let group = null;
            let groupKey = null;
            for (const [gk, gv] of setGroups.entries()) {
              if ((gv.items || []).some(it => it.key === lineKey)) {
                group = gv;
                groupKey = gk;
                break;
              }
            }

            if (group && group.info.isMultiSize && groupKey) {
              const currentItem = group.items.find(i => i.key === lineKey);
              if (currentItem) {
                if (requestedQty > cartItem.quantity) {
                  await updateMultiSizeSet(groupKey, 'increase');
                } else if (requestedQty < cartItem.quantity) {
                  await updateMultiSizeSet(groupKey, 'decrease');
                }

                return new Response(JSON.stringify({ success: true }), { status: 200 });
              }
            }
          }
        } catch (error) {
          log('Mini cart intercept hatası:', error);
        }
      }
      
      return originalFetch.call(this, url, options);
    };
  }
  
  // ÇOK BELİRGİN ortak toast helper — top center, büyük, bounce animasyonlu
  function _wholesaleCartShowToast(opts) {
    const { id, title, message, icon, bgColor, fgColor, duration = 4000 } = opts;
    try {
      document.querySelectorAll('.wholesale-toast-' + id).forEach(el => el.remove());

      const toast = document.createElement('div');
      toast.className = 'wholesale-toast wholesale-toast-' + id;
      toast.setAttribute('role', 'alert');
      toast.setAttribute('aria-live', 'assertive');
      toast.style.cssText = `
        position: fixed;
        top: 32px;
        left: 50%;
        transform: translateX(-50%) translateY(-120px) scale(0.95);
        z-index: 2147483647;
        min-width: 360px;
        max-width: min(560px, 92vw);
        padding: 22px 28px;
        border-radius: 12px;
        background: ${bgColor};
        color: ${fgColor};
        box-shadow: 0 20px 60px rgba(0,0,0,0.35), 0 0 0 1px rgba(0,0,0,0.08);
        font-size: 16px;
        line-height: 1.45;
        display: flex;
        align-items: center;
        gap: 18px;
        opacity: 0;
        transition: opacity 350ms ease, transform 450ms cubic-bezier(0.34, 1.56, 0.64, 1);
        font-family: inherit;
        pointer-events: auto;
      `;
      toast.innerHTML = `
        ${icon ? `<div style="flex-shrink:0; width:44px; height:44px; border-radius:50%; background:rgba(255,255,255,0.18); display:flex; align-items:center; justify-content:center;">${icon}</div>` : ''}
        <div style="flex:1; min-width:0;">
          <div style="font-weight:800; letter-spacing:0.6px; text-transform:uppercase; font-size:12px; opacity:0.92; margin-bottom:4px;">${title}</div>
          <div style="font-weight:500; font-size:16px; line-height:1.4;">${message}</div>
        </div>
      `;
      document.body.appendChild(toast);
      requestAnimationFrame(() => {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0) scale(1)';
      });
      setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(-30px) scale(0.95)';
        setTimeout(() => toast.remove(), 400);
      }, duration);
    } catch (e) {
      log('Cart toast hatası:', e);
    }
  }

  // Sepette max lota vurulduğunda — siyah, sade
  function showCartMaxNotification(maxSets) {
    _wholesaleCartShowToast({
      id: 'max',
      title: maxSets > 0 ? T('stockLimit') : T('soldOut'),
      message: maxSets > 0 ? T('lastInStock') : T('productSoldOut'),
      icon: '',
      bgColor: '#1a1a1a',
      fgColor: '#fff',
      duration: 3500
    });
  }

  // Bildirim — tüm tipler siyah, sade
  function showNotification(message, type = 'info') {
    const titles = { success: T('cartUpdated'), info: T('info'), warning: T('warning') };
    _wholesaleCartShowToast({
      id: 'note',
      title: titles[type] || titles.info,
      message: message,
      icon: '',
      bgColor: '#1a1a1a',
      fgColor: '#fff',
      duration: 3000
    });
  }
  
  // CSS
  function addStyles() {
    if (document.querySelector('#cart-set-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'cart-set-styles';
    style.textContent = `
      @keyframes slideInBounce {
        0% { 
          transform: translateX(120%) scale(0.8);
          opacity: 0;
        }
        60% {
          transform: translateX(-10%) scale(1.02);
          opacity: 1;
        }
        100% { 
          transform: translateX(0) scale(1);
          opacity: 1;
        }
      }
      @keyframes slideOutBounce {
        from { 
          transform: translateX(0) scale(1);
          opacity: 1;
        }
        to { 
          transform: translateX(120%) scale(0.8);
          opacity: 0;
        }
      }
      @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Event listeners
  function addEventListeners() {
    document.addEventListener('cart:refresh', () => {
      setTimeout(setupCartPageControls, 500);
    });
    
    document.addEventListener('cart:updated', () => {
      setTimeout(setupCartPageControls, 500);
    });
  }
  
  // DOM observer — debounce + guard ile sonsuz döngü önlenir
  function observeChanges() {
    let observerDebounce = null;
    let isApplyingFromObserver = false;

    const observer = new MutationObserver((mutations) => {
      // Plugin kendi DOM mutate ediyorsa observer'ı tekrar tetikleme
      if (isApplyingFromObserver || isUpdating) return;
      // Cart container yoksa hiç çalışma
      if (!document.querySelector('cart-items')) return;

      // Plugin'in eklediği elementleri (.cart-item__wholesale-set, .multi-size-badge, .single-variant-badge)
      // ile değişiklikleri yok say — kendi mutate'lerimizi tetikleyici sayma
      let externalChange = false;
      for (const m of mutations) {
        // Eklenen veya silinen node'lar arasında plugin'in eklediği bir badge/summary varsa skip
        const nodes = [...(m.addedNodes || []), ...(m.removedNodes || [])];
        for (const n of nodes) {
          if (n.nodeType !== 1) continue;
          if (n.classList && (n.classList.contains('cart-item__wholesale-set') ||
                              n.classList.contains('multi-size-badge') ||
                              n.classList.contains('single-variant-badge'))) {
            continue;
          }
          externalChange = true;
          break;
        }
        if (externalChange) break;
      }
      if (!externalChange) return;

      // Debounce: kısa süre içinde birden fazla mutation gelirse bir kerede işle
      clearTimeout(observerDebounce);
      observerDebounce = setTimeout(async () => {
        isApplyingFromObserver = true;
        try {
          await setupCartPageControls();
        } finally {
          // Plugin'in DOM mutate'leri tamamlanana kadar küçük bir delay
          setTimeout(() => { isApplyingFromObserver = false; }, 100);
        }
      }, 250);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // GLOBAL kaldır handler — document level capture, DOM yenilemesinden etkilenmez
  let globalRemoveHandlerInstalled = false;
  function installGlobalRemoveHandler() {
    if (globalRemoveHandlerInstalled) return;
    globalRemoveHandlerInstalled = true;
    console.log('[Cart Set] ✓ Global remove handler kuruldu (document-level capture)');

    document.addEventListener('click', async (e) => {
      const target = e.target.closest(
        '[data-cart-remove], button[data-cart-remove], a[href*="/cart/change"][href*="quantity=0"], a[aria-label*="kaldır" i], .cart-remove, .remove-item'
      );
      if (!target) return;

      console.log('[Cart Set] >>> KALDIR TIKLANDI <<<', target);

      const cartItem = target.closest('[data-cart-line], [data-cart-item], .cart-item, .cart__item, line-item, tr[data-product-id]');
      if (!cartItem) {
        console.warn('[Cart Set] cartItem ancestor bulunamadı, müdahale edilmiyor');
        return;
      }

      // Item key'i çıkar
      let itemKey = target.dataset.lineKey || target.dataset.cartItemKey || cartItem.dataset.lineKey || null;
      if (!itemKey) {
        const href = target.href || target.getAttribute('href');
        if (href) {
          const m = href.match(/[?&]id=([^&]+)/);
          if (m) itemKey = m[1];
        }
      }
      if (!itemKey) {
        const qi = cartItem.querySelector('input[name*="updates"]');
        if (qi) {
          const m = qi.name.match(/updates\[([^\]]+)\]/);
          if (m) itemKey = m[1];
        }
      }
      const lineIndex = target.dataset.line || cartItem.dataset.cartLine;

      console.log('[Cart Set] Çözümlenen — itemKey:', itemKey, '| lineIndex:', lineIndex);

      // ÖNEMLİ: Plugin'in set kontrolünden ÖNCE preventDefault yap.
      // Tema'nın <cart-items>.onClick handler'ı bubble phase'te çalışır;
      // capture phase'te yakalayınca hemen durdur, sonra async kontrol.
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Set olup olmadığını taze cart fetch ile kontrol et
      let isSetItem = false;
      let resolvedHandle = null;
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        let cartLineItem = null;
        if (itemKey) {
          cartLineItem = cart.items.find(i => i.key === itemKey);
        } else if (lineIndex) {
          cartLineItem = cart.items[parseInt(lineIndex, 10) - 1];
          if (cartLineItem) itemKey = cartLineItem.key;
        }
        if (cartLineItem) {
          resolvedHandle = cartLineItem.handle || cartLineItem.url?.split('/products/')[1]?.split('?')[0];
          const setInfo = resolvedHandle ? await getProductSetInfo(resolvedHandle) : null;
          if (setInfo && setInfo.isMultiSize) {
            isSetItem = true;
          }
          console.log('[Cart Set] Cart item bulundu — handle:', resolvedHandle, '| isMultiSize:', isSetItem);
        } else {
          console.warn('[Cart Set] Cart item bulunamadı! itemKey:', itemKey);
        }
      } catch (err) {
        console.error('[Cart Set] Global remove: cart fetch hatası:', err);
      }

      if (!isSetItem) {
        // Set değilse manuel olarak normal silme yap (tema handler'ını zaten engelledik)
        console.log('[Cart Set] Set değil, normal silme yapılıyor');
        if (itemKey) {
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: itemKey, quantity: 0 })
            });
            await refreshCart();
          } catch (err) {
            console.error('[Cart Set] Tek satır silme hatası:', err);
            window.location.reload();
          }
        } else {
          window.location.reload();
        }
        return;
      }

      // SET ürünü — tüm bedenleri sil
      if (itemKey) {
        console.log('[Cart Set] >>> SET KALDIRMA başlıyor — itemKey:', itemKey);
        const success = await removeCompleteSet(itemKey);
        console.log('[Cart Set] removeCompleteSet sonuç:', success);
      } else {
        console.warn('[Cart Set] itemKey yok, sayfa yenileniyor');
        window.location.reload();
      }
    }, true); // CAPTURE phase
  }

  // Ana başlatma
  async function init() {
    log('Cart Set Multiplier başlatılıyor...');

    addStyles();
    installGlobalRemoveHandler(); // ← document-level kaldır handler (DOM yenilense de çalışır)
    interceptMiniCart();
    await setupCartPageControls();
    addEventListeners();
    observeChanges();

    log('Hazır! Set grupları:', setGroups);
  }
  
  // DOM hazır olduğunda başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();